import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { UserPermissions, GlobalRole, ImpersonationUser } from '@/auth/permissions.types';

interface AuthState {
  permissions: UserPermissions | null;
  setPermissions: (p: UserPermissions) => void;
  clearPermissions: () => void;
  hasRole: (role: GlobalRole) => boolean;
  hasAnyRole: (roles: GlobalRole[]) => boolean;
  // Impersonation
  impersonatedUser: ImpersonationUser | null;
  setImpersonatedUser: (user: ImpersonationUser | null) => void;
  isImpersonating: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      permissions: null,
      setPermissions: (permissions) => set({ permissions }),
      clearPermissions: () => set({ permissions: null }),
      hasRole: (role) => get().permissions?.globalRoles.includes(role) ?? false,
      hasAnyRole: (roles) => roles.some((role) => get().hasRole(role)),
      // Impersonation
      impersonatedUser: null,
      setImpersonatedUser: (user) => set({ impersonatedUser: user }),
      isImpersonating: () => get().impersonatedUser !== null,
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
